export // French holidays up to 2050
const frenchHolidays = new Set<string>([
  "2019-01-01",
  "2019-04-22",
  "2019-05-01",
  "2019-05-08",
  "2019-05-30",
  "2019-06-10",
  "2019-07-14",
  "2019-08-15",
  "2019-11-01",
  "2019-11-11",
  "2019-12-25",
  "2020-01-01",
  "2020-04-13",
  "2020-05-01",
  "2020-05-08",
  "2020-05-21",
  "2020-06-01",
  "2020-07-14",
  "2020-08-15",
  "2020-11-01",
  "2020-11-11",
  "2020-12-25",
  "2021-01-01",
  "2021-04-05",
  "2021-05-01",
  "2021-05-08",
  "2021-05-13",
  "2021-05-24",
  "2021-07-14",
  "2021-08-15",
  "2021-11-01",
  "2021-11-11",
  "2021-12-25",
  "2022-01-01",
  "2022-04-18",
  "2022-05-01",
  "2022-05-08",
  "2022-05-26",
  "2022-06-06",
  "2022-07-14",
  "2022-08-15",
  "2022-11-01",
  "2022-11-11",
  "2022-12-25",
  "2023-01-01",
  "2023-04-10",
  "2023-05-01",
  "2023-05-08",
  "2023-05-18",
  "2023-05-29",
  "2023-07-14",
  "2023-08-15",
  "2023-11-01",
  "2023-11-11",
  "2023-12-25",
  "2024-01-01",
  "2024-04-01",
  "2024-05-01",
  "2024-05-08",
  "2024-05-09",
  "2024-05-20",
  "2024-07-14",
  "2024-08-15",
  "2024-11-01",
  "2024-11-11",
  "2024-12-25",
  "2025-01-01",
  "2025-04-21",
  "2025-05-01",
  "2025-05-08",
  "2025-05-29",
  "2025-06-09",
  "2025-07-14",
  "2025-08-15",
  "2025-11-01",
  "2025-11-11",
  "2025-12-25",
  "2026-01-01",
  "2026-04-06",
  "2026-05-01",
  "2026-05-08",
  "2026-05-14",
  "2026-05-25",
  "2026-07-14",
  "2026-08-15",
  "2026-11-01",
  "2026-11-11",
  "2026-12-25",
  "2027-01-01",
  "2027-03-29",
  "2027-05-01",
  "2027-05-06",
  "2027-05-08",
  "2027-05-17",
  "2027-07-14",
  "2027-08-15",
  "2027-11-01",
  "2027-11-11",
  "2027-12-25",
  "2028-01-01",
  "2028-04-17",
  "2028-05-01",
  "2028-05-08",
  "2028-05-25",
  "2028-06-05",
  "2028-07-14",
  "2028-08-15",
  "2028-11-01",
  "2028-11-11",
  "2028-12-25",
  "2029-01-01",
  "2029-04-02",
  "2029-05-01",
  "2029-05-08",
  "2029-05-10",
  "2029-05-21",
  "2029-07-14",
  "2029-08-15",
  "2029-11-01",
  "2029-11-11",
  "2029-12-25",
  "2030-01-01",
  "2030-04-22",
  "2030-05-01",
  "2030-05-08",
  "2030-05-30",
  "2030-06-10",
  "2030-07-14",
  "2030-08-15",
  "2030-11-01",
  "2030-11-11",
  "2030-12-25",
  "2031-01-01",
  "2031-04-14",
  "2031-05-01",
  "2031-05-08",
  "2031-05-22",
  "2031-06-02",
  "2031-07-14",
  "2031-08-15",
  "2031-11-01",
  "2031-11-11",
  "2031-12-25",
  "2032-01-01",
  "2032-03-29",
  "2032-05-01",
  "2032-05-06",
  "2032-05-08",
  "2032-05-17",
  "2032-07-14",
  "2032-08-15",
  "2032-11-01",
  "2032-11-11",
  "2032-12-25",
  "2033-01-01",
  "2033-04-18",
  "2033-05-01",
  "2033-05-08",
  "2033-05-26",
  "2033-06-06",
  "2033-07-14",
  "2033-08-15",
  "2033-11-01",
  "2033-11-11",
  "2033-12-25",
  "2034-01-01",
  "2034-04-10",
  "2034-05-01",
  "2034-05-08",
  "2034-05-18",
  "2034-05-29",
  "2034-07-14",
  "2034-08-15",
  "2034-11-01",
  "2034-11-11",
  "2034-12-25",
  "2035-01-01",
  "2035-03-26",
  "2035-05-01",
  "2035-05-03",
  "2035-05-08",
  "2035-05-14",
  "2035-07-14",
  "2035-08-15",
  "2035-11-01",
  "2035-11-11",
  "2035-12-25",
  "2036-01-01",
  "2036-04-14",
  "2036-05-01",
  "2036-05-08",
  "2036-05-22",
  "2036-06-02",
  "2036-07-14",
  "2036-08-15",
  "2036-11-01",
  "2036-11-11",
  "2036-12-25",
  "2037-01-01",
  "2037-04-06",
  "2037-05-01",
  "2037-05-08",
  "2037-05-14",
  "2037-05-25",
  "2037-07-14",
  "2037-08-15",
  "2037-11-01",
  "2037-11-11",
  "2037-12-25",
  "2038-01-01",
  "2038-04-26",
  "2038-05-01",
  "2038-05-08",
  "2038-06-03",
  "2038-06-14",
  "2038-07-14",
  "2038-08-15",
  "2038-11-01",
  "2038-11-11",
  "2038-12-25",
  "2039-01-01",
  "2039-04-11",
  "2039-05-01",
  "2039-05-08",
  "2039-05-19",
  "2039-05-30",
  "2039-07-14",
  "2039-08-15",
  "2039-11-01",
  "2039-11-11",
  "2039-12-25",
  "2040-01-01",
  "2040-04-02",
  "2040-05-01",
  "2040-05-08",
  "2040-05-10",
  "2040-05-21",
  "2040-07-14",
  "2040-08-15",
  "2040-11-01",
  "2040-11-11",
  "2040-12-25",
  "2041-01-01",
  "2041-04-22",
  "2041-05-01",
  "2041-05-08",
  "2041-05-30",
  "2041-06-10",
  "2041-07-14",
  "2041-08-15",
  "2041-11-01",
  "2041-11-11",
  "2041-12-25",
  "2042-01-01",
  "2042-04-07",
  "2042-05-01",
  "2042-05-08",
  "2042-05-15",
  "2042-05-26",
  "2042-07-14",
  "2042-08-15",
  "2042-11-01",
  "2042-11-11",
  "2042-12-25",
  "2043-01-01",
  "2043-03-30",
  "2043-05-01",
  "2043-05-07",
  "2043-05-08",
  "2043-05-18",
  "2043-07-14",
  "2043-08-15",
  "2043-11-01",
  "2043-11-11",
  "2043-12-25",
  "2044-01-01",
  "2044-04-18",
  "2044-05-01",
  "2044-05-08",
  "2044-05-26",
  "2044-06-06",
  "2044-07-14",
  "2044-08-15",
  "2044-11-01",
  "2044-11-11",
  "2044-12-25",
  "2045-01-01",
  "2045-04-10",
  "2045-05-01",
  "2045-05-08",
  "2045-05-18",
  "2045-05-29",
  "2045-07-14",
  "2045-08-15",
  "2045-11-01",
  "2045-11-11",
  "2045-12-25",
  "2046-01-01",
  "2046-03-26",
  "2046-05-01",
  "2046-05-03",
  "2046-05-08",
  "2046-05-14",
  "2046-07-14",
  "2046-08-15",
  "2046-11-01",
  "2046-11-11",
  "2046-12-25",
  "2047-01-01",
  "2047-04-15",
  "2047-05-01",
  "2047-05-08",
  "2047-05-23",
  "2047-06-03",
  "2047-07-14",
  "2047-08-15",
  "2047-11-01",
  "2047-11-11",
  "2047-12-25",
  "2048-01-01",
  "2048-04-06",
  "2048-05-01",
  "2048-05-08",
  "2048-05-14",
  "2048-05-25",
  "2048-07-14",
  "2048-08-15",
  "2048-11-01",
  "2048-11-11",
  "2048-12-25",
  "2049-01-01",
  "2049-04-19",
  "2049-05-01",
  "2049-05-08",
  "2049-05-27",
  "2049-06-07",
  "2049-07-14",
  "2049-08-15",
  "2049-11-01",
  "2049-11-11",
  "2049-12-25",
  "2050-01-01",
  "2050-04-11",
  "2050-05-01",
  "2050-05-08",
  "2050-05-19",
  "2050-05-30",
  "2050-07-14",
  "2050-08-15",
  "2050-11-01",
  "2050-11-11",
  "2050-12-25",
]);
